export const PagesModelModule = angular
    .module('app.services.model.models.pagesModel', [])
    .value('pagesModel', {
        name: 'String',
        content: 'String',
        revision: 'Number',
        seo: {
            title: 'String',
            metaDescription: 'String',
            friendlyName: 'String',
            modifier: 'String'
        },
        isActive: ['Boolean', true],
        tenant: 'String'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/pages.model.js